import React, { useEffect, useState } from "react";
import StackedBarChart from "../utils/StackedBarChart";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";

const LineChartCopy = ({ tab }) => {
  const btns = ["Weekly", "Monthly", "Yearly"];
  const [graph, setGraph] = useState({});
  const [activeDuration, setActiveDuration] = useState("yearly");

  const dates = [];
  const disbursements = [];
  const pledged = [];
  const [loading, setLoading] = useState(false);

  const getDashboardUserDetails = async () => {
    setLoading(true);
    let url = "";
    const token = localStorage.getItem("token");
    if (tab !== "all")
      url = `${process.env.REACT_APP_URL}/lender/v1/dashboards/dp_analysis_graph?tab=${tab}&duration=${activeDuration}`;
    else
      url = `${process.env.REACT_APP_URL}/lender/v1/dashboards/dp_analysis_graph?duration=${activeDuration}`;
    const options = {
      url: url,
      method: "GET",
      headers: { Authorization: token },
    };
    const res = await axios(options);
    setGraph(res.data.data);
    setLoading(false);
  };

  function removeYear(inputString) {
    const words = inputString.split(" ");

    // Check if the last word is a year (numeric and four digits)
    if (words.length >= 3 && /^\d{4}$/.test(words[words.length - 1])) {
      // Check if the second last word is a month (case-insensitive)
      const monthNames = [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ];
      const lastWord = words[words.length - 2].toLowerCase();
      if (monthNames.includes(lastWord)) {
        // If it's in the format "day month year", remove the year
        words.pop(); // Remove the last word (year)
      }
    }

    return words.join(" ");
  }

  for (const key in graph) {
    dates.push(removeYear(key));
    disbursements.push(graph[key].disbursal_amount);
    pledged.push(graph[key].pledged_value);
  }

  useEffect(() => {
    getDashboardUserDetails();
  }, [activeDuration, tab]);

  return (
    <>
      {loading ? (
        <div className="flex w-full h-full justify-center items-center">
          <ImageLoading />
        </div>
      ) : (
        <>
          {" "}
          <div className=" pt-4 h-full  ">
            <div className="flex justify-between items-center mb-[22px] ml-4">
              <p className="text-[16px] font-semibold">Disbursement-Pledged</p>
              <div className="flex  bg-[#f1f1f6] rounded-[12px] p-[2px] px-[3px] mr-4 items-center h-[25px]">
                {btns.map((btn, index) => (
                  <>
                    <button
                      key={index}
                      className={`${
                        activeDuration === btn.toLowerCase()
                          ? "bg-[#a0ff77]  text-[#262626]"
                          : "bg-[#f1f1f6]  text-[#848484]"
                      }   text-xs   rounded-[10px] px-3 py-[2px]`}
                      onClick={() => setActiveDuration(btn.toLowerCase())}
                    >
                      {btn}
                    </button>
                  </>
                ))}
              </div>
            </div>
            <div className="  pl-[27.5px]">
              <StackedBarChart
                dates={dates}
                disbursements={disbursements}
                pledged={pledged}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LineChartCopy;
